/**
 * @description 能力图谱
 */
import {
  getCapabilityFrame,
  getCapabilityFrameAll,
  addCapabilityFrame,
  editCapabilityFrame,
  deleteCapabilityFrame,
  updateCapabilityFrameStatus,
  getCapabilityConfiguration,
  getCapabilityFrameDetail,
  getCourseCapability,
  getCourseCapabilitySearchParam,
  getCourseCapabilityStatPagination,
  getCourseCapabilityStatStudent,
  getCapabilityMap,
  getCapabilityStep1,
  getCapabilityStep2,
  getCapabilityStep3,
  submitCapabilityStep1,
  submitCapabilityStep2,
  submitCapabilityStep3,
  getCapabilityConfigurationSection,
  getCapabilityConfigurationActivity,
  getCapabilityTotal,
  getCapabilityGraphConfig,
  getCapabilityCourseGraphList,
  getCapabilityMajorAll,
  getCapabilityGradeAll,
  getCapabilitySectionList,
  saveCapabilitySection,
  deleteCapabilitySection,
  getCapabilityCourseDetail,
  getCapabilityCourseStatStudent,
  getCapabilityAiSuggestion,
  getCapabilityNoMapGraph,
  getCapabilityUpdatePriv
} from '@/api/capability'

const state = () => ({
})

const getters = {}
// 同步方法写在这里--对应commit
const mutations = {
}
const actions = {
  // 获取框架列表
  // eslint-disable-next-line no-empty-pattern
  getCapabilityFrame({}, data) {
    return new Promise((resolve, reject) => {
      getCapabilityFrame(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 获取框架全部数据
  // eslint-disable-next-line no-empty-pattern
  getCapabilityFrameAll({}, data) {
    return new Promise((resolve, reject) => {
      getCapabilityFrameAll(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 新增框架
  // eslint-disable-next-line no-empty-pattern
  addCapabilityFrame({}, data) {
    return new Promise((resolve, reject) => {
      addCapabilityFrame(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 编辑框架
  // eslint-disable-next-line no-empty-pattern
  editCapabilityFrame({}, data) {
    return new Promise((resolve, reject) => {
      editCapabilityFrame(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 删除框架
  // eslint-disable-next-line no-empty-pattern
  deleteCapabilityFrame({}, data) {
    return new Promise((resolve, reject) => {
      deleteCapabilityFrame(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 更新框架共享状态
  // eslint-disable-next-line no-empty-pattern
  updateCapabilityFrameStatus({}, data) {
    return new Promise((resolve, reject) => {
      updateCapabilityFrameStatus(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 查看框架详情
  // eslint-disable-next-line no-empty-pattern
  getCapabilityFrameDetail({}, data) {
    return new Promise((resolve, reject) => {
      getCapabilityFrameDetail(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 获取评价指标
  // eslint-disable-next-line no-empty-pattern
  getCapabilityConfiguration({}, data) {
    return new Promise((resolve, reject) => {
      getCapabilityConfiguration(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 获取课程能力达成
  // eslint-disable-next-line no-empty-pattern
  getCourseCapability({}, data) {
    return new Promise((resolve, reject) => {
      getCourseCapability(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 课程全部学生达成情况筛选条件
  // eslint-disable-next-line no-empty-pattern
  getCourseCapabilitySearchParam({}, data) {
    return new Promise((resolve, reject) => {
      getCourseCapabilitySearchParam(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 课程全部学生达成情况分页查询
  // eslint-disable-next-line no-empty-pattern
  getCourseCapabilityStatPagination({}, data) {
    return new Promise((resolve, reject) => {
      getCourseCapabilityStatPagination(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 课程全部学生达成情况分页查询
  // eslint-disable-next-line no-empty-pattern
  getCourseCapabilityStatStudent({}, data) {
    return new Promise((resolve, reject) => {
      getCourseCapabilityStatStudent(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 获取能力图谱概况
  // eslint-disable-next-line no-empty-pattern
  getCapabilityMap({}, data) {
    return new Promise((resolve, reject) => {
      getCapabilityMap(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // eslint-disable-next-line no-empty-pattern
  getCapabilityStep1({}, data) {
    return new Promise((resolve, reject) => {
      getCapabilityStep1(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // eslint-disable-next-line no-empty-pattern
  getCapabilityStep2({}, data) {
    return new Promise((resolve, reject) => {
      getCapabilityStep2(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // eslint-disable-next-line no-empty-pattern
  getCapabilityStep3({}, data) {
    return new Promise((resolve, reject) => {
      getCapabilityStep3(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // eslint-disable-next-line no-empty-pattern
  submitCapabilityStep1({}, data) {
    return new Promise((resolve, reject) => {
      submitCapabilityStep1(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // eslint-disable-next-line no-empty-pattern
  submitCapabilityStep2({}, data) {
    return new Promise((resolve, reject) => {
      submitCapabilityStep2(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // eslint-disable-next-line no-empty-pattern
  submitCapabilityStep3({}, data) {
    return new Promise((resolve, reject) => {
      submitCapabilityStep3(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // eslint-disable-next-line no-empty-pattern
  getCapabilityConfigurationSection({}, data) {
    return new Promise((resolve, reject) => {
      getCapabilityConfigurationSection(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // eslint-disable-next-line no-empty-pattern
  getCapabilityConfigurationActivity({}, data) {
    return new Promise((resolve, reject) => {
      getCapabilityConfigurationActivity(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // eslint-disable-next-line no-empty-pattern
  getCapabilityTotal({}, data) {
    return new Promise((resolve, reject) => {
      getCapabilityTotal(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // eslint-disable-next-line no-empty-pattern
  getCapabilityGraphConfig({}, data) {
    return new Promise((resolve, reject) => {
      getCapabilityGraphConfig(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // eslint-disable-next-line no-empty-pattern
  getCapabilityCourseGraphList({}, data) {
    return new Promise((resolve, reject) => {
      getCapabilityCourseGraphList(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // eslint-disable-next-line no-empty-pattern
  getCapabilityMajorAll({}, data) {
    return new Promise((resolve, reject) => {
      getCapabilityMajorAll(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // eslint-disable-next-line no-empty-pattern
  getCapabilityGradeAll({}, data) {
    return new Promise((resolve, reject) => {
      getCapabilityGradeAll(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // eslint-disable-next-line no-empty-pattern
  getCapabilitySectionList({}, data) {
    return new Promise((resolve, reject) => {
      getCapabilitySectionList(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // eslint-disable-next-line no-empty-pattern
  saveCapabilitySection({}, data) {
    return new Promise((resolve, reject) => {
      saveCapabilitySection(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // eslint-disable-next-line no-empty-pattern
  deleteCapabilitySection({}, data) {
    return new Promise((resolve, reject) => {
      deleteCapabilitySection(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // eslint-disable-next-line no-empty-pattern
  getCapabilityCourseDetail({}, data) {
    return new Promise((resolve, reject) => {
      getCapabilityCourseDetail(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // eslint-disable-next-line no-empty-pattern
  getCapabilityCourseStatStudent({}, data) {
    return new Promise((resolve, reject) => {
      getCapabilityCourseStatStudent(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // eslint-disable-next-line no-empty-pattern
  getCapabilityAiSuggestion({}, data) {
    return new Promise((resolve, reject) => {
      getCapabilityAiSuggestion(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // eslint-disable-next-line no-empty-pattern
  getCapabilityNoMapGraph({}) {
    return new Promise((resolve, reject) => {
      getCapabilityNoMapGraph()
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 获取能力图谱配置权限,传courseId
  // eslint-disable-next-line no-empty-pattern
  getCapabilityUpdatePriv({}, data) {
    return new Promise((resolve, reject) => {
      getCapabilityUpdatePriv(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
}

export default { state, getters, mutations, actions }